export default "__VITE_ASSET__qUMbThoa__"